// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ============================================
// Cart Goals Functionality - v5.0 MUTATION OBSERVER
// ============================================

(function() {
  'use strict';
  
  console.log('[Cart Goals] Script loaded! Version 5.0 MUTATION OBSERVER');

  // Global state storage
  let globalCartState = null;
  let globalInstance = null;

  class CartGoals {
    constructor(initialCart) {
      console.log('[Cart Goals] Constructor called with cart:', initialCart);
      
      this.container = document.querySelector('[data-cart-goals]');
      
      if (!this.container) {
        console.log('[Cart Goals] Element not found');
        return;
      }
      
      console.log('[Cart Goals] Element found!');

      this.progressFill = this.container.querySelector('.cart-goals__progress-fill');
      this.descriptionEl = this.container.querySelector('.cart-goals__description');
      this.successEl = this.container.querySelector('.cart-goals__success');
      this.freeProductsEl = this.container.querySelector('.cart-goals__free-products');
      this.milestones = Array.from(this.container.querySelectorAll('.cart-goals__milestone'));

      console.log('[Cart Goals] Elements found:');
      console.log('  - Progress fill:', this.progressFill ? 'YES' : 'NO');
      console.log('  - Description:', this.descriptionEl ? 'YES' : 'NO');
      console.log('  - Success:', this.successEl ? 'YES' : 'NO');
      console.log('  - Milestones:', this.milestones.length);
      
      // Global goal configuration
      this.goalType = this.container.dataset.goalType;
      this.xValue = parseInt(this.container.dataset.xValue);
      this.autoAddFreeProducts = this.container.dataset.autoAddFreeProducts === 'true';

      // Color customization
      this.progressColor = this.container.dataset.progressColor || '#4CAF50';
      this.progressBgColor = this.container.dataset.progressBgColor || '#e0e0e0';
      this.descriptionColor = this.container.dataset.descriptionColor || '#333333';
      this.successBgColor = this.container.dataset.successBgColor || '#4CAF50';
      this.successTextColor = this.container.dataset.successTextColor || '#ffffff';
      this.activeMilestoneColor = this.container.dataset.activeMilestoneColor || '#4CAF50';
      this.completedMilestoneColor = this.container.dataset.completedMilestoneColor || '#4CAF50';
      this.milestoneDefaultBorder = this.container.dataset.milestoneDefaultBorder || '#e0e0e0';
      this.milestoneDefaultIcon = this.container.dataset.milestoneDefaultIcon || '#999999';
      this.freeBadgeBg = this.container.dataset.freeBadgeBg || '#4CAF50';
      this.freeBadgeText = this.container.dataset.freeBadgeText || '#ffffff';
      this.unlockedOverlayColor = this.container.dataset.unlockedOverlayColor || '#4CAF50';
      this.unlockedOverlayOpacity = parseInt(this.container.dataset.unlockedOverlayOpacity || '15');
      this.unlockedItemBg = this.container.dataset.unlockedItemBg || '#ffffff';
      this.lockedBadgeBg = this.container.dataset.lockedBadgeBg || '#999999';
      this.lockedBadgeText = this.container.dataset.lockedBadgeText || '#ffffff';
      this.lockedOverlayColor = this.container.dataset.lockedOverlayColor || '#c8c8c8';
      this.lockedOverlayOpacity = parseInt(this.container.dataset.lockedOverlayOpacity || '30');
      this.lockedItemBg = this.container.dataset.lockedItemBg || '#ffffff';

      this.xProducts = this.parseProductIds(this.container.dataset.xProducts);

      this.successMessage = this.container.dataset.successMessage;
      this.enableConfetti = this.container.dataset.enableConfetti === 'true';

      // Parse milestone-specific Y values and products
      this.milestoneData = this.milestones.map(milestone => {
        const yValue = parseInt(milestone.dataset.milestoneYValue) || 0;
        const yProducts = this.parseProductIds(milestone.dataset.milestoneYProducts);
        const yProductHandles = milestone.dataset.milestoneYProductHandles ?
          milestone.dataset.milestoneYProductHandles.split(',').map(h => h.trim()).filter(h => h !== '') : [];
        const lockedText = milestone.dataset.milestoneLockedText || 'Complete goals to unlock';

        const milestoneData = {
          index: parseInt(milestone.dataset.milestoneIndex),
          yValue: yValue,
          yProducts: yProducts,
          yProductHandles: yProductHandles,
          lockedText: lockedText
        };

        console.log('[Cart Goals] Parsed milestone', milestoneData.index, ':', milestoneData);
        return milestoneData;
      });

      console.log('[Cart Goals] Total milestones:', this.milestoneData.length);

      // Create a combined list of ALL Y products across all milestones (for identification purposes)
      this.allYProducts = [];
      this.milestoneData.forEach(md => {
        md.yProducts.forEach(pid => {
          if (!this.allYProducts.includes(pid)) {
            this.allYProducts.push(pid);
          }
        });
      });

      console.log('[Cart Goals] All Y products:', this.allYProducts);
      console.log('[Cart Goals] X Value:', this.xValue, '(from dataset:', this.container.dataset.xValue, ')');
      console.log('[Cart Goals] X Products:', this.xProducts, '(from dataset:', this.container.dataset.xProducts, ')');
      console.log('[Cart Goals] Goal Type:', this.goalType);
      console.log('[Cart Goals] Auto-add enabled:', this.autoAddFreeProducts);

      this.confettiShownEver = false; // Track if confetti has ever been shown this session
      this.freeProductsAdded = false;
      this.isAddingFreeProducts = false; // Prevent concurrent free product additions
      this.manuallyRemovedFreeProducts = false; // Track if user manually removed free products
      this.updateDebounceTimer = null; // Debounce timer for updates
      this.lastCartItemCount = 0; // Track last cart item count to detect user removals
      this.isUpdating = false; // Prevent concurrent updates
      this.pendingUpdate = false; // Track if update is pending
      
      // Apply color customization
      this.applyColors();
      
      // If we have initial cart state, use it immediately
      if (initialCart) {
        console.log('[Cart Goals] Using initial cart state');
        this.updateProgress(initialCart);
      } else {
        // Otherwise fetch
        this.fetchCartAndUpdate();
      }
    }

    applyColors() {
      // Set CSS custom properties on the quick-cart wrapper or body to ensure they're available everywhere
      // Try to find the quick-cart wrapper first, fall back to body
      const quickCartWrapper = document.querySelector('.quick-cart__wrapper') ||
                               document.querySelector('.quick-cart') ||
                               document.body;

      // Helper to convert hex to rgba
      const hexToRgba = (hex, opacity) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
      };

      // Set CSS custom properties on the wrapper for global scope
      quickCartWrapper.style.setProperty('--cart-active-milestone-color', this.activeMilestoneColor);
      quickCartWrapper.style.setProperty('--cart-completed-milestone-color', this.completedMilestoneColor);
      quickCartWrapper.style.setProperty('--cart-milestone-default-border', this.milestoneDefaultBorder);
      quickCartWrapper.style.setProperty('--cart-milestone-default-icon', this.milestoneDefaultIcon);
      quickCartWrapper.style.setProperty('--cart-free-badge-bg', this.freeBadgeBg);
      quickCartWrapper.style.setProperty('--cart-free-badge-text', this.freeBadgeText);
      quickCartWrapper.style.setProperty('--cart-locked-badge-bg', this.lockedBadgeBg);
      quickCartWrapper.style.setProperty('--cart-locked-badge-text', this.lockedBadgeText);

      // Set item background colors
      quickCartWrapper.style.setProperty('--cart-unlocked-item-bg', this.unlockedItemBg);
      quickCartWrapper.style.setProperty('--cart-locked-item-bg', this.lockedItemBg);

      // Set overlay colors with opacity
      quickCartWrapper.style.setProperty('--cart-unlocked-overlay', hexToRgba(this.unlockedOverlayColor, this.unlockedOverlayOpacity));
      quickCartWrapper.style.setProperty('--cart-unlocked-overlay-light', hexToRgba(this.unlockedOverlayColor, Math.max(5, this.unlockedOverlayOpacity - 5)));
      quickCartWrapper.style.setProperty('--cart-unlocked-overlay-strong', hexToRgba(this.unlockedOverlayColor, Math.min(60, this.unlockedOverlayOpacity + 25)));
      quickCartWrapper.style.setProperty('--cart-locked-overlay', hexToRgba(this.lockedOverlayColor, this.lockedOverlayOpacity));
      quickCartWrapper.style.setProperty('--cart-locked-overlay-strong', hexToRgba(this.lockedOverlayColor, Math.min(70, this.lockedOverlayOpacity + 20)));

      // Apply inline styles for specific elements
      if (this.progressFill && this.progressColor) {
        this.progressFill.style.background = this.progressColor;
      }
      if (this.descriptionEl && this.descriptionColor) {
        this.descriptionEl.style.color = this.descriptionColor;
      }
      if (this.successEl) {
        if (this.successBgColor) {
          this.successEl.style.background = this.successBgColor;
        }
        if (this.successTextColor) {
          this.successEl.style.color = this.successTextColor;
        }
      }

      // Inject dynamic pulse animation with custom colors
      this.injectPulseAnimation();
    }

    injectPulseAnimation() {
      // Remove existing dynamic pulse style if it exists
      const existingStyle = document.getElementById('cart-goals-pulse-animation');
      if (existingStyle) {
        existingStyle.remove();
      }

      // Helper to convert hex to rgba
      const hexToRgba = (hex, opacity) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      // Create dynamic pulse animation with custom colors
      const activeMilestoneRgba = (opacity) => hexToRgba(this.activeMilestoneColor, opacity);

      const styleEl = document.createElement('style');
      styleEl.id = 'cart-goals-pulse-animation';
      styleEl.textContent = `
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 2px 6px ${activeMilestoneRgba(0.3)};
          }
          50% {
            box-shadow: 0 2px 12px ${activeMilestoneRgba(0.6)}, 0 0 20px ${activeMilestoneRgba(0.4)};
          }
        }
      `;
      document.head.appendChild(styleEl);
    }

    parseProductIds(str) {
      if (!str || str === '') return [];
      const ids = str.split(',')
        .map(id => id.trim())
        .filter(id => id !== '')
        .map(id => parseInt(id))
        .filter(id => !isNaN(id));
      return ids;
    }

    async fetchCartAndUpdate() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        console.log('[Cart Goals] Fetched cart');
        globalCartState = cart; // Store globally
        this.updateProgress(cart);
      } catch (error) {
        console.error('[Cart Goals] Error fetching cart:', error);
      }
    }

    updateProgress(cart) {
      // Call immediately without debounce for now
      this._doUpdateProgress(cart);
    }

    _doUpdateProgress(cart) {
      if (!cart || !cart.items) {
        console.log('[Cart Goals] No cart or items');
        return;
      }

      // Prevent concurrent updates
      if (this.isUpdating) {
        console.log('[Cart Goals] Already updating, marking pending update');
        this.pendingUpdate = true;
        return;
      }

      this.isUpdating = true;

      // CRITICAL FIX: Re-query all DOM elements before each update
      // The drawer refresh replaces elements, making references stale
      this.container = document.querySelector('[data-cart-goals]');
      if (!this.container) {
        console.log('[Cart Goals] Container element not found after re-query');
        this.isUpdating = false;
        return;
      }

      this.progressFill = this.container.querySelector('.cart-goals__progress-fill');
      this.descriptionEl = this.container.querySelector('.cart-goals__description');
      this.successEl = this.container.querySelector('.cart-goals__success');
      this.freeProductsEl = this.container.querySelector('.cart-goals__free-products');
      this.milestones = Array.from(this.container.querySelectorAll('.cart-goals__milestone'));

      console.log('[Cart Goals] Re-queried elements - Progress fill:', this.progressFill ? 'FOUND' : 'NOT FOUND');

      // Store globally
      globalCartState = cart;

      const cartItems = cart.items;
      console.log('[Cart Goals] Updating progress. Cart items:', cartItems.length);

      // Check if free products were manually removed
      const hasFreeProductInCart = cart.items.some(item => {
        return this.allYProducts.includes(item.product_id) ||
               (item.properties && item.properties._cart_goal_free_product === 'true');
      });

      // If we previously had free products added and now they're gone, mark as manually removed
      if (this.freeProductsAdded && !hasFreeProductInCart) {
        console.log('[Cart Goals] Free products were manually removed by user');
        this.manuallyRemovedFreeProducts = true;
      }
      
      // Count matching items in cart (excluding Y products and free products)
      const matchingItemsCount = this.getMatchingItemsCount(cartItems, this.xProducts);
      console.log('[Cart Goals] Matching items count:', matchingItemsCount);
      
      // Determine how many milestones are completed
      const completedMilestones = Math.min(matchingItemsCount, this.xValue);
      const allCompleted = completedMilestones >= this.xValue;
      
      console.log('[Cart Goals] Milestones completed:', completedMilestones, '/', this.xValue);
      
      // Update each milestone
      this.milestones.forEach((milestone, index) => {
        const milestoneNumber = index + 1;
        
        if (milestoneNumber <= completedMilestones) {
          milestone.classList.add('is-completed');
          milestone.classList.remove('is-active');
        } else if (milestoneNumber === completedMilestones + 1) {
          milestone.classList.add('is-active');
          milestone.classList.remove('is-completed');
        } else {
          milestone.classList.remove('is-completed', 'is-active');
        }
      });
      
      // Update progress bar
      const progressPercentage = this.xValue > 0 ? (completedMilestones / this.xValue) * 100 : 0;

      if (this.progressFill) {
        this.progressFill.style.width = progressPercentage + '%';
        console.log('[Cart Goals] Progress bar set to:', progressPercentage + '%', 'Element:', this.progressFill);
      } else {
        console.error('[Cart Goals] ERROR: Progress fill element not found!');
      }
      
      // Determine the current milestone (the highest completed milestone)
      const currentMilestoneIndex = completedMilestones - 1; // 0-indexed
      const currentMilestone = currentMilestoneIndex >= 0 ? this.milestoneData[currentMilestoneIndex] : null;

      console.log('[Cart Goals] Current milestone:', currentMilestone ? currentMilestone.index : 'none');

      // Check if milestone has changed from last update
      if (this.lastMilestoneIndex !== undefined && this.lastMilestoneIndex !== currentMilestoneIndex) {
        console.log('[Cart Goals] !!!! MILESTONE CHANGED from milestone index', this.lastMilestoneIndex, '(milestone', this.lastMilestoneIndex + 1, ') to milestone index', currentMilestoneIndex, '(milestone', currentMilestoneIndex >= 0 ? currentMilestoneIndex + 1 : 'none', ') - resetting flags');
        this.freeProductsAdded = false;
        this.isAddingFreeProducts = false;
        this.manuallyRemovedFreeProducts = false;
      }

      // CRITICAL: If we're on the same milestone but user changed quantity, reset the flag
      // This allows the system to stay responsive even when milestone doesn't change
      if (this.lastMilestoneIndex === currentMilestoneIndex && this.freeProductsAdded) {
        console.log('[Cart Goals] Same milestone but cart changed - resetting freeProductsAdded flag to allow updates');
        this.freeProductsAdded = false;
      }

      this.lastMilestoneIndex = currentMilestoneIndex;

      // Update description and handle goal completion
      if (allCompleted) {
        console.log('[Cart Goals] ALL GOALS COMPLETED!');
        this.showSuccess();

        // For buy_x_get_y_free type with auto-add enabled
        if (this.goalType === 'buy_x_get_y_free' && this.autoAddFreeProducts) {
          console.log('[Cart Goals] Auto-add is ENABLED, will check if free products needed');

          // Check if ANY free products exist in cart (not just for this milestone)
          const anyFreeProducts = cart.items.filter(item => {
            return this.allYProducts.includes(item.product_id) ||
                   (item.properties && item.properties._cart_goal_free_product === 'true');
          });

          // Check if existing free products match current milestone
          let needsUpdate = false;
          if (anyFreeProducts.length === 0) {
            console.log('[Cart Goals] No free products - needs update');
            needsUpdate = true;
          } else {
            const mismatchedProducts = anyFreeProducts.filter(item => {
              const itemMilestone = item.properties && item.properties._milestone;
              const matches = itemMilestone === currentMilestone.index.toString();
              console.log('[Cart Goals] Checking free product:', item.product_title, 'milestone:', itemMilestone, 'expected:', currentMilestone.index, 'matches:', matches);
              return !matches;
            });

            if (mismatchedProducts.length > 0) {
              console.log('[Cart Goals] Found', mismatchedProducts.length, 'mismatched free products at goal complete - needs update');
              needsUpdate = true;
            }
          }

          // Add/update if needed - BUT check if we're already adding to prevent re-triggering
          if (!this.manuallyRemovedFreeProducts && currentMilestone && currentMilestone.yValue > 0 && needsUpdate && !this.isAddingFreeProducts && !this.freeProductsAdded) {
            setTimeout(() => {
              console.log('[Cart Goals] Calling addFreeProductsToCart for completed milestone', currentMilestone.index);
              this.addFreeProductsToCart(currentMilestone);
            }, 100);
          } else {
            console.log('[Cart Goals] Skipping auto-add: manually removed =', this.manuallyRemovedFreeProducts, ', milestone Y =', currentMilestone ? currentMilestone.yValue : 0, ', needs update =', needsUpdate, ', is adding =', this.isAddingFreeProducts, ', already added =', this.freeProductsAdded);
          }
        }
      } else {
        // Reset manual removal flag when goal is no longer complete
        if (this.manuallyRemovedFreeProducts) {
          console.log('[Cart Goals] Goal no longer complete, resetting manual removal flag');
          this.manuallyRemovedFreeProducts = false;
        }
        // Goals not complete
        console.log('[Cart Goals] Goals NOT complete yet. Completed:', completedMilestones, 'Need:', this.xValue);

        const nextMilestoneIndex = completedMilestones;
        if (nextMilestoneIndex < this.milestones.length) {
          const nextMilestone = this.milestones[nextMilestoneIndex];
          const description = nextMilestone.dataset.milestoneDescription;

          this.descriptionEl.innerHTML = this.replaceVariables(
            description,
            matchingItemsCount,
            cart,
            nextMilestoneIndex
          );
        }
        this.hideSuccess();

        // Handle auto-add for intermediate milestones
        if (this.goalType === 'buy_x_get_y_free' && this.autoAddFreeProducts) {
          // Check if ANY free products exist in cart
          const anyFreeProducts = cart.items.filter(item => {
            return this.allYProducts.includes(item.product_id) ||
                   (item.properties && item.properties._cart_goal_free_product === 'true');
          });

          // If NO milestone reached (completedMilestones === 0) but free products exist, REMOVE them
          if (completedMilestones === 0 && anyFreeProducts.length > 0 && !this.isAddingFreeProducts) {
            console.log('[Cart Goals] No milestone reached but free products exist - removing them');
            setTimeout(() => {
              this.removeFreeProductFromCart(cart);
            }, 50);
          }
          // Find the highest completed milestone that has Y products
          else if (completedMilestones > 0) {
            // Search backwards from the highest completed milestone to find one with Y products
            let targetMilestone = null;
            for (let i = completedMilestones - 1; i >= 0; i--) {
              if (this.milestoneData[i] && this.milestoneData[i].yValue > 0) {
                targetMilestone = this.milestoneData[i];
                console.log('[Cart Goals] Found target milestone with Y products:', targetMilestone.index);
                break;
              }
            }

            if (targetMilestone) {
              // Check if the existing free products match the target milestone
              let needsUpdate = false;

              if (anyFreeProducts.length === 0) {
                console.log('[Cart Goals] No free products in cart - needs update');
                needsUpdate = true;
              } else {
                // Check each free product's milestone property
                const mismatchedProducts = anyFreeProducts.filter(item => {
                  const itemMilestone = item.properties && item.properties._milestone;
                  const matches = itemMilestone === targetMilestone.index.toString();
                  console.log('[Cart Goals] Checking free product:', item.product_title, 'milestone:', itemMilestone, 'expected:', targetMilestone.index, 'matches:', matches);
                  return !matches;
                });

                if (mismatchedProducts.length > 0) {
                  console.log('[Cart Goals] Found', mismatchedProducts.length, 'mismatched free products - needs update');
                  needsUpdate = true;
                } else {
                  console.log('[Cart Goals] All free products match target milestone - no update needed');
                }
              }

              if (needsUpdate && !this.manuallyRemovedFreeProducts && !this.isAddingFreeProducts && !this.freeProductsAdded) {
                setTimeout(() => {
                  console.log('[Cart Goals] Calling addFreeProductsToCart for intermediate milestone', targetMilestone.index);
                  this.addFreeProductsToCart(targetMilestone);
                }, 100);
              } else {
                console.log('[Cart Goals] Skipping intermediate add: needs update =', needsUpdate, ', manually removed =', this.manuallyRemovedFreeProducts, ', is adding =', this.isAddingFreeProducts, ', already added =', this.freeProductsAdded);
              }
            }
            // If no milestone with Y products found, remove any existing free products
            else if (anyFreeProducts.length > 0 && !this.isAddingFreeProducts) {
              console.log('[Cart Goals] No completed milestone has Y products but free products exist - removing them');
              setTimeout(() => {
                this.removeFreeProductFromCart(cart);
              }, 50);
            }
          }
        }
      }

      // ALWAYS hide real free product items first
      this.hideRealFreeProductItems(cart);

      // Handle disabled free item display for buy_x_get_y_free
      if (this.goalType === 'buy_x_get_y_free') {
        this.updateDisabledFreeItem(completedMilestones, cart);
      }

      // Update cart count
      this.updateCartCount(cart);

      // Release update lock
      this.isUpdating = false;

      // If there's a pending update, process it now
      if (this.pendingUpdate) {
        console.log('[Cart Goals] Processing pending update');
        this.pendingUpdate = false;
        setTimeout(() => {
          this.fetchCartAndUpdate();
        }, 100);
      }
    }

    async updateDisabledFreeItem(completedMilestones, cart) {
      // Find or create the disabled free item in the cart items list
      const cartItemsContainer = document.querySelector('.quick-cart__items');
      if (!cartItemsContainer) return;

      // Get ALL existing disabled items - we'll remove all and recreate
      const allExistingDisabledItems = cartItemsContainer.querySelectorAll('.quick-cart__item--free-goal-disabled');

      // Always remove all existing previews first
      allExistingDisabledItems.forEach(item => item.remove());

      // Determine current milestone (completed)
      const currentMilestoneIndex = completedMilestones - 1;
      const currentMilestone = currentMilestoneIndex >= 0 ? this.milestoneData[currentMilestoneIndex] : null;

      // Determine NEXT milestone (for locked display)
      const nextMilestoneIndex = completedMilestones;
      const nextMilestone = nextMilestoneIndex < this.milestoneData.length ? this.milestoneData[nextMilestoneIndex] : null;

      const goalComplete = completedMilestones >= this.xValue;

      // Count matching items to determine if we should show disabled item
      const matchingItemsCount = this.getMatchingItemsCount(cart.items, this.xProducts);

      // Check if actual free products are in cart
      const freeProductsInCart = cart.items.filter(item => {
        return this.allYProducts.includes(item.product_id) ||
               (item.properties && item.properties._cart_goal_free_product === 'true');
      });
      const hasFreeProductInCart = freeProductsInCart.length > 0;

      if (this.autoAddFreeProducts) {
        // CASE 1: Show added free products for CURRENT milestone
        if (hasFreeProductInCart && completedMilestones > 0) {
          console.log('[Cart Goals] Creating "Added" previews for completed milestones');

          // Group free products by product ID and count quantities
          const productQuantities = {};
          freeProductsInCart.forEach(item => {
            if (!productQuantities[item.product_id]) {
              productQuantities[item.product_id] = {
                quantity: 0,
                title: item.product_title,
                image: item.image,
                price: item.price,
                handle: item.handle
              };
            }
            productQuantities[item.product_id].quantity += item.quantity;
          });

          // Create a preview for each unique product showing "Added"
          Object.values(productQuantities).forEach(prodInfo => {
            this.createDisabledFreeItemDirect(prodInfo, true, cartItemsContainer, true);
          });

          // ALSO show locked items for NEXT milestone (if exists and has Y products)
          if (nextMilestone && nextMilestone.yValue > 0) {
            console.log('[Cart Goals] Also creating "Locked" previews for next milestone', nextMilestoneIndex + 1);
            const nextYProductHandles = nextMilestone.yProductHandles;
            const nextYValue = nextMilestone.yValue;

            // Get list of handles already added as free products
            const addedHandles = Object.values(productQuantities).map(p => p.handle);
            console.log('[Cart Goals] Already added product handles:', addedHandles);

            // Calculate how many of each product to show for next milestone
            const nextProductCounts = {};
            for (let i = 0; i < nextYValue; i++) {
              const handle = nextYProductHandles[i % nextYProductHandles.length];
              // Only add if NOT already in the added free products
              if (!addedHandles.includes(handle)) {
                nextProductCounts[handle] = (nextProductCounts[handle] || 0) + 1;
              } else {
                console.log('[Cart Goals] Skipping locked item for', handle, '- already added as free product');
              }
            }

            // Create one locked preview per unique product with its quantity
            for (const handle in nextProductCounts) {
              await this.createDisabledFreeItem(handle, false, cartItemsContainer, false, nextProductCounts[handle], nextMilestone);
            }
          }

        } else if (hasFreeProductInCart && completedMilestones === 0) {
          // Free product is in cart but goal no longer met - remove them
          console.log('[Cart Goals] Goal no longer met, removing free products from cart');
          this.removeFreeProductFromCart(cart);
          return;
        } else if (matchingItemsCount > 0 && !hasFreeProductInCart) {
          // CASE 2: Show LOCKED preview items for NEXT milestone that has Y products
          // Find the next milestone with Y products
          let targetMilestoneForPreview = null;
          for (let i = completedMilestones; i < this.milestoneData.length; i++) {
            if (this.milestoneData[i] && this.milestoneData[i].yValue > 0) {
              targetMilestoneForPreview = this.milestoneData[i];
              console.log('[Cart Goals] Found next milestone with Y products for preview:', targetMilestoneForPreview.index);
              break;
            }
          }

          if (targetMilestoneForPreview) {
            console.log('[Cart Goals] Creating "Locked" previews for milestone', targetMilestoneForPreview.index);
            const yProductHandles = targetMilestoneForPreview.yProductHandles;
            const yValue = targetMilestoneForPreview.yValue;

            // Calculate how many of each product to show
            const productCounts = {};
            for (let i = 0; i < yValue; i++) {
              const handle = yProductHandles[i % yProductHandles.length];
              productCounts[handle] = (productCounts[handle] || 0) + 1;
            }

            // Create one locked preview per unique product with its quantity
            for (const handle in productCounts) {
              await this.createDisabledFreeItem(handle, false, cartItemsContainer, false, productCounts[handle], targetMilestoneForPreview);
            }
          }
        }
        return;
      }

      // For non-auto-add mode
      if (hasFreeProductInCart) {
        // Don't show preview if real products exist
        return;
      }

      if (matchingItemsCount > 0) {
        // Show locked preview
        const yProductHandle = yProductHandles[0];
        if (yProductHandle) {
          await this.createDisabledFreeItem(yProductHandle, goalComplete, cartItemsContainer, false, yValue);
        }
      }
    }

    getProductsToAdd(yValue, yProductHandles) {
      // Distribute Y value across available product handles
      const products = [];
      for (let i = 0; i < yValue; i++) {
        products.push(yProductHandles[i % yProductHandles.length]);
      }
      return products;
    }

    async createDisabledFreeItemDirect(prodInfo, goalComplete, cartItemsContainer, isAdded = false) {
      // Create preview from actual cart item data
      const variantText = prodInfo.quantity > 1 ? `Free Gift - Qty: ${prodInfo.quantity}` : 'Free Gift';
      const badgeLabel = '✓ Added to cart!';
      const badgeClass = 'cart-goals__added-badge';
      const itemClasses = 'quick-cart__item--unlocked quick-cart__item--added';

      // Get badge colors
      const badgeBg = this.freeBadgeBg;
      const badgeTextColor = this.freeBadgeText;
      const itemBg = this.unlockedItemBg;

      const disabledItemHTML = `
        <div class="quick-cart__item quick-cart__item--free-goal-disabled ${itemClasses}" data-free-goal-item style="background: ${itemBg};">
          <div class="quick-cart__item-image">
            ${prodInfo.image ? `<img src="${prodInfo.image}" alt="${prodInfo.title}" loading="lazy" style="width: 100%; height: auto;">` : ''}
          </div>
          <div class="quick-cart__item-details">
            <div class="quick-cart__item-top">
              <h4 class="quick-cart__item-title fs-product-card-title">${prodInfo.title}</h4>
              <p class="quick-cart__item-variant fs-body-60 t-opacity-50">${variantText}</p>
              <div class="quick-cart__item-price-wrapper fs-body-75">
                <s class="quick-cart__item-price">${this.formatMoney(prodInfo.price)}</s>
                <span class="quick-cart__item-price sale-price">FREE</span>
              </div>
            </div>
            <div class="quick-cart__item-bottom">
              <div class="cart-goals__free-product-badge ${badgeClass}" style="background: ${badgeBg}; color: ${badgeTextColor};">${badgeLabel}</div>
            </div>
          </div>
        </div>
      `;

      const crossSells = cartItemsContainer.querySelector('[data-cross-sells]');
      if (crossSells) {
        crossSells.insertAdjacentHTML('beforebegin', disabledItemHTML);
      } else {
        cartItemsContainer.insertAdjacentHTML('beforeend', disabledItemHTML);
      }
    }

    hideRealFreeProductItems(cart) {
      // Hide the real free product cart items (Shopify-added ones)
      const cartItemsContainer = document.querySelector('.quick-cart__items');
      if (!cartItemsContainer) return;

      // Find all real cart items (exclude our preview items)
      const allCartItems = cartItemsContainer.querySelectorAll('.quick-cart__item:not(.quick-cart__item--free-goal-disabled)');

      allCartItems.forEach(item => {
        const itemKey = item.dataset.key;
        if (!itemKey) return;

        // Find this item in cart data
        const cartItem = cart.items.find(ci => ci.key === itemKey);
        if (!cartItem) return;

        // Check if this is a free product
        const isFreeProduct = this.allYProducts.includes(cartItem.product_id) ||
                              (cartItem.properties && cartItem.properties._cart_goal_free_product === 'true');

        if (isFreeProduct) {
          // FORCE HIDE this real cart item - use important styles and remove from flow
          item.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
          item.classList.add('quick-cart__item--hidden-free');
          item.setAttribute('aria-hidden', 'true');
          console.log('[Cart Goals] Hiding real free product cart item:', cartItem.product_id, cartItem.product_title);
        } else {
          // Make sure non-free items are visible
          if (item.classList.contains('quick-cart__item--hidden-free')) {
            item.style.cssText = '';
            item.classList.remove('quick-cart__item--hidden-free');
            item.removeAttribute('aria-hidden');
          }
        }
      });
    }

    async createDisabledFreeItem(productHandle, goalComplete, cartItemsContainer, isAdded = false, quantity = 1, milestone = null) {
      try {
        // Fetch product info
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) return;

        const product = await response.json();

        // Determine badge text and classes
        let badgeLabel, badgeClass, variantText, itemClasses, badgeBg, badgeTextColor, itemBg;

        if (isAdded) {
          badgeLabel = '✓ Added to cart!';
          badgeClass = 'cart-goals__added-badge';
          variantText = quantity > 1 ? `Free Gift - Qty: ${quantity}` : 'Free Gift';
          itemClasses = 'quick-cart__item--unlocked quick-cart__item--added';
          badgeBg = this.freeBadgeBg;
          badgeTextColor = this.freeBadgeText;
          itemBg = this.unlockedItemBg;
        } else if (goalComplete) {
          badgeLabel = '✓ Adding...';
          badgeClass = '';
          variantText = quantity > 1 ? `Free Gift - Adding... Qty: ${quantity}` : 'Free Gift - Adding...';
          itemClasses = 'quick-cart__item--unlocked';
          badgeBg = this.freeBadgeBg;
          badgeTextColor = this.freeBadgeText;
          itemBg = this.unlockedItemBg;
        } else {
          badgeLabel = '🔒 Locked';
          badgeClass = 'cart-goals__locked-badge';
          // Use milestone locked text if available, otherwise use default
          variantText = milestone && milestone.lockedText ? milestone.lockedText : 'Complete goals to unlock';
          itemClasses = 'quick-cart__item--locked';
          badgeBg = this.lockedBadgeBg;
          badgeTextColor = this.lockedBadgeText;
          itemBg = this.lockedItemBg;
        }

        // Create disabled item HTML with quantity display
        const disabledItemHTML = `
          <div class="quick-cart__item quick-cart__item--free-goal-disabled ${itemClasses}" data-free-goal-item style="background: ${itemBg};">
            <div class="quick-cart__item-image">
              ${product.featured_image ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy" style="width: 100%; height: auto;">` : ''}
            </div>
            <div class="quick-cart__item-details">
              <div class="quick-cart__item-top">
                <h4 class="quick-cart__item-title fs-product-card-title">${product.title}</h4>
                <p class="quick-cart__item-variant fs-body-60 t-opacity-50">${variantText}</p>
                <div class="quick-cart__item-price-wrapper fs-body-75">
                  <s class="quick-cart__item-price">${this.formatMoney(product.price)}</s>
                  <span class="quick-cart__item-price sale-price">FREE</span>
                </div>
              </div>
              <div class="quick-cart__item-bottom">
                <div class="cart-goals__free-product-badge ${badgeClass}" style="background: ${badgeBg}; color: ${badgeTextColor};">${badgeLabel}</div>
              </div>
            </div>
          </div>
        `;

        // Insert at the end of cart items (before cross-sells if they exist)
        const crossSells = cartItemsContainer.querySelector('[data-cross-sells]');
        if (crossSells) {
          crossSells.insertAdjacentHTML('beforebegin', disabledItemHTML);
        } else {
          cartItemsContainer.insertAdjacentHTML('beforeend', disabledItemHTML);
        }
      } catch (error) {
        console.error('[Cart Goals] Error creating disabled item:', error);
      }
    }

    formatMoney(cents) {
      // Use the theme's money format
      const format = window.theme?.moneyFormat || '${{amount}}';

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
          return '0';
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    getMatchingItemsCount(cartItems, productIds) {
      // Count items that match X products, but EXCLUDE Y products
      if (productIds.length === 0) {
        // If no X products specified, count ALL products EXCEPT Y products
        const total = cartItems.reduce((sum, item) => {
          // Skip if this is a Y product (reward product from ANY milestone)
          const isYProduct = this.allYProducts.includes(item.product_id);

          // Skip if this has the free product property
          const isFreeProduct = item.properties && item.properties._cart_goal_free_product === 'true';

          if (isYProduct || isFreeProduct) {
            return sum; // Don't count this item
          }

          return sum + item.quantity;
        }, 0);
        return total;
      }

      const count = cartItems.reduce((sum, item) => {
        // Skip Y products and free products
        const isYProduct = this.allYProducts.includes(item.product_id);
        const isFreeProduct = item.properties && item.properties._cart_goal_free_product === 'true';

        if (isYProduct || isFreeProduct) {
          return sum; // Don't count this item towards X
        }

        const matchesByProductId = productIds.includes(item.product_id);

        if (matchesByProductId) {
          return sum + item.quantity;
        }

        return sum;
      }, 0);

      return count;
    }

    replaceVariables(text, currentCount, cart, milestoneIndex = null) {
      const needed = this.xValue;
      const remaining = Math.max(0, needed - currentCount);

      // Get Y value from milestone if available
      let yValue = 0;
      if (milestoneIndex !== null && this.milestoneData[milestoneIndex]) {
        yValue = this.milestoneData[milestoneIndex].yValue;
      }

      const formatMoney = (cents) => {
        // Use this.formatMoney method which handles theme's money format
        return this.formatMoney(cents);
      };

      const cartTotal = cart.total_price;
      let amount = '';
      let amountOff = '';

      if (this.goalType === 'buy_x_at_price_y') {
        amount = formatMoney(yValue);
        amountOff = formatMoney(Math.max(0, cartTotal - yValue));
      } else if (this.goalType === 'buy_x_get_y_free') {
        const avgItemPrice = cart.items.length > 0 ?
          cartTotal / cart.items.reduce((sum, item) => sum + item.quantity, 0) : 0;
        amountOff = formatMoney(avgItemPrice * yValue);
      }

      return text
        .replace(/\[products_current\]/g, currentCount)
        .replace(/\[products_needed\]/g, needed)
        .replace(/\[products_remaining\]/g, remaining)
        .replace(/\[y_value\]/g, yValue)
        .replace(/\[amount\]/g, amount)
        .replace(/\[amount_off\]/g, amountOff);
    }

    showSuccess() {
      if (this.descriptionEl) {
        this.descriptionEl.innerHTML = '';
      }

      // Hide the description wrapper to prevent empty space
      const descriptionWrapper = this.container.querySelector('.cart-goals__description-wrapper');
      if (descriptionWrapper) {
        descriptionWrapper.style.display = 'none';
      }

      // Add padding-top to cart-goals container to prevent overlap
      if (this.container) {
        this.container.style.paddingTop = '20px';
      }

      if (this.successEl) {
        this.successEl.classList.remove('hidden');
      }

      // Only show confetti once per session
      if (this.enableConfetti && !this.confettiShownEver) {
        this.confettiShownEver = true;
        this.triggerConfetti();
      }
    }

    hideSuccess() {
      // Show the description wrapper again
      const descriptionWrapper = this.container.querySelector('.cart-goals__description-wrapper');
      if (descriptionWrapper) {
        descriptionWrapper.style.display = '';
      }

      // Remove padding-top from cart-goals container
      if (this.container) {
        this.container.style.paddingTop = '';
      }

      if (this.successEl) {
        this.successEl.classList.add('hidden');
      }
      // Don't reset confettiShownEver - it should stay true for the session
    }

    showFreeProducts() {
      if (this.freeProductsEl && this.goalType === 'buy_x_get_y_free') {
        this.freeProductsEl.classList.remove('hidden');
      }
    }

    hideFreeProducts() {
      if (this.freeProductsEl) {
        this.freeProductsEl.classList.add('hidden');
      }
    }
    
    updateFreeProductsDisplay(isGoalComplete) {
      // This manages the display of Y products based on goal completion state
      if (!this.freeProductsEl || this.goalType !== 'buy_x_get_y_free') {
        return;
      }
      
      const freeProducts = this.freeProductsEl.querySelectorAll('.cart-goals__free-product');
      
      freeProducts.forEach(freeProductEl => {
        const itemEl = freeProductEl.querySelector('.quick-cart__item--disabled');
        const variantText = freeProductEl.querySelector('.quick-cart__item-variant');
        const badge = freeProductEl.querySelector('.cart-goals__free-product-badge');
        
        if (isGoalComplete) {
          // Goal complete: Show as unlocked/free
          if (itemEl) {
            itemEl.classList.remove('quick-cart__item--locked');
            itemEl.classList.add('quick-cart__item--unlocked');
          }
          if (variantText) {
            variantText.textContent = 'Free Gift - Unlocked!';
          }
          if (badge) {
            badge.textContent = '🎁 Free Gift';
            badge.classList.remove('cart-goals__locked-badge');
          }
        } else {
          // Goal incomplete: Show as locked
          if (itemEl) {
            itemEl.classList.add('quick-cart__item--locked');
            itemEl.classList.remove('quick-cart__item--unlocked');
          }
          if (variantText) {
            variantText.textContent = 'Locked - Complete goals to unlock';
          }
          if (badge) {
            badge.textContent = '🔒 Locked';
            badge.classList.add('cart-goals__locked-badge');
          }
        }
      });
    }

    async addFreeProductsToCart(milestone) {
      console.log('[Cart Goals] Adding free products for milestone', milestone.index);

      // Prevent concurrent executions
      if (this.isAddingFreeProducts) {
        console.log('[Cart Goals] Already adding free products, skipping...');
        return;
      }

      this.isAddingFreeProducts = true;

      // Set a flag to prevent any updates during this process
      this.isUpdating = true;

      try {
        // First, get current cart to see what's already there
        const cartResponse = await fetch('/cart.js');
        const currentCart = await cartResponse.json();

        // Get the Y value and products for this milestone
        const yValue = milestone.yValue;
        const yProductHandles = milestone.yProductHandles;

        if (yValue === 0 || yProductHandles.length === 0) {
          console.log('[Cart Goals] Milestone has no Y value or products, skipping');
          this.isAddingFreeProducts = false;
          this.isUpdating = false;
          return;
        }

        console.log('[Cart Goals] Milestone Y value:', yValue, 'Products:', yProductHandles);

        // Check ALL free products in cart
        const allFreeProductsInCart = currentCart.items.filter(item => {
          const isFreeProduct = this.allYProducts.includes(item.product_id) ||
                               (item.properties && item.properties._cart_goal_free_product === 'true');
          return isFreeProduct;
        });

        console.log('[Cart Goals] Found', allFreeProductsInCart.length, 'total free products in cart');

        // Check if the existing free products ALL match this milestone
        const allMatchThisMilestone = allFreeProductsInCart.every(item => {
          const itemMilestone = item.properties && item.properties._milestone;
          return itemMilestone === milestone.index.toString();
        });

        // Count total QUANTITY of items that match this milestone
        const matchingQuantity = allFreeProductsInCart
          .filter(item => {
            const itemMilestone = item.properties && item.properties._milestone;
            return itemMilestone === milestone.index.toString();
          })
          .reduce((sum, item) => sum + item.quantity, 0);

        // Only skip if ALL free products match this milestone AND total quantity is correct
        if (allFreeProductsInCart.length > 0 && allMatchThisMilestone && matchingQuantity === yValue) {
          console.log('[Cart Goals] All free products (qty:', matchingQuantity, ') already match milestone', milestone.index, '- skipping');
          this.isAddingFreeProducts = false;
          this.isUpdating = false;
          return;
        }

        console.log('[Cart Goals] Need to update free products - removing ALL existing free products first');

        // ALWAYS remove ALL free products first to ensure clean state
        await this.removeAllFreeProducts(currentCart);

        // Now add the free products for this milestone
        const productsToAdd = yProductHandles.slice(0, yValue);
        console.log('[Cart Goals] Will add', productsToAdd.length, 'different products');

        // Build items array - each unique product gets added once
        const itemsToAdd = [];
        const productQuantities = {};

        // Count how many times each product should be added
        for (let i = 0; i < yValue; i++) {
          const handle = yProductHandles[i % yProductHandles.length];
          productQuantities[handle] = (productQuantities[handle] || 0) + 1;
        }

        console.log('[Cart Goals] Product quantities:', productQuantities);

        // Fetch variant IDs and build items array
        for (const handle in productQuantities) {
          const quantity = productQuantities[handle];
          const productResponse = await fetch(`/products/${handle}.js`);
          if (productResponse.ok) {
            const product = await productResponse.json();
            itemsToAdd.push({
              id: product.variants[0].id,
              quantity: quantity,
              properties: {
                '_cart_goal_free_product': 'true',
                '_free_item_price': '0',
                '_milestone': milestone.index.toString()
              }
              // NOTE: To ensure free products don't contribute to cart subtotal,
              // you need to implement ONE of these backend solutions:
              // 1. Shopify Scripts (Plus only): Line item script to set price to $0
              // 2. Shopify Functions: Discount function to set price to $0
              // 3. Use the _cart_goal_free_product property to filter in cart.liquid
              // The property '_cart_goal_free_product' = 'true' identifies free items
            });
          }
        }

        if (itemsToAdd.length === 0) {
          console.log('[Cart Goals] No items to add');
          this.isAddingFreeProducts = false;
          this.isUpdating = false;
          return;
        }

        console.log('[Cart Goals] Adding items:', itemsToAdd);

        const formData = { items: itemsToAdd };

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (addResponse.ok) {
          console.log('[Cart Goals] Successfully added free products');

          // Mark that we've added free products
          this.freeProductsAdded = true;

          // IMPORTANT: Release locks BEFORE triggering drawer refresh
          // This ensures the refresh event handler doesn't see locked state
          this.isAddingFreeProducts = false;
          this.isUpdating = false;

          // Trigger drawer refresh immediately to update the HTML
          document.dispatchEvent(new CustomEvent('quick-cart:updated'));

          console.log('[Cart Goals] Triggered drawer refresh with locks released');
        } else {
          console.error('[Cart Goals] Failed to add free products');
          // Release locks on failure too
          this.isAddingFreeProducts = false;
          this.isUpdating = false;
        }

      } catch (error) {
        console.error('[Cart Goals] Error adding free products:', error);
        // Always release locks on error
        this.isAddingFreeProducts = false;
        this.isUpdating = false;
      }
    }

    async removeAllFreeProducts(cart) {
      console.log('[Cart Goals] Removing all free products from previous milestones');

      try {
        // Find all free product items in cart
        const freeItems = cart.items.filter(item => {
          const isFreeVariant = this.allYProducts.includes(item.product_id);
          const hasFreeProperty = item.properties && item.properties._cart_goal_free_product === 'true';
          return isFreeVariant || hasFreeProperty;
        });

        console.log('[Cart Goals] Found', freeItems.length, 'free items to remove');

        if (freeItems.length === 0) {
          console.log('[Cart Goals] No free items to remove');
          return;
        }

        // Remove all free products in parallel for speed
        await Promise.all(freeItems.map(item =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }).then(() => console.log('[Cart Goals] Removed free product with key:', item.key))
        ));

        console.log('[Cart Goals] All free products removed');
      } catch (error) {
        console.error('[Cart Goals] Error removing all free products:', error);
      }
    }

    async removeFreeProductFromCart(cart) {
      console.log('[Cart Goals] Removing free product from cart (goal no longer met)');

      // Block updates during removal
      this.isUpdating = true;

      try {
        // Find free product items in cart
        const freeItems = cart.items.filter(item => {
          const isFreeVariant = this.allYProducts.includes(item.product_id);
          const hasFreeProperty = item.properties && item.properties._cart_goal_free_product === 'true';
          return isFreeVariant || hasFreeProperty;
        });

        console.log('[Cart Goals] Found', freeItems.length, 'free items to remove');

        if (freeItems.length === 0) {
          this.isUpdating = false;
          return;
        }

        // Remove all free products in parallel for speed
        await Promise.all(freeItems.map(item =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }).then(() => console.log('[Cart Goals] Removed free product with key:', item.key))
        ));

        // IMPORTANT: Release locks BEFORE triggering drawer refresh
        this.isUpdating = false;
        this.isAddingFreeProducts = false;

        // Trigger drawer refresh immediately to update display and re-enable buttons
        document.dispatchEvent(new CustomEvent('quick-cart:updated'));

        console.log('[Cart Goals] Free products removed, locks released, and drawer refreshed');
      } catch (error) {
        console.error('[Cart Goals] Error removing free product:', error);
        // Always release locks on error
        this.isUpdating = false;
        this.isAddingFreeProducts = false;
      }
    }


    updateCartCount(cart) {
      console.log('[Cart Goals] Updating cart count. Raw cart.item_count:', cart.item_count);

      // Actual count = total cart items (includes free products)
      let actualCount = cart.item_count;

      // Update cart count in the quick cart heading
      const heading = document.querySelector('.quick-cart__heading');
      if (heading) {
        const sup = heading.querySelector('sup');
        if (actualCount > 0) {
          if (sup) {
            sup.textContent = actualCount;
          } else {
            const newSup = document.createElement('sup');
            newSup.textContent = actualCount;
            heading.appendChild(newSup);
          }
        } else {
          // If count is 0, remove the sup element
          if (sup) {
            sup.remove();
          }
        }
      }

      // Update header cart icon count (common selectors)
      const headerCartCounts = document.querySelectorAll('[data-cart-count], [data-js-cart-count], .cart-count, .header__cart-count');
      headerCartCounts.forEach(countEl => {
        countEl.textContent = actualCount;
        // Also update data attribute if present
        if (countEl.hasAttribute('data-cart-count')) {
          countEl.setAttribute('data-cart-count', actualCount);
        }
        if (countEl.hasAttribute('data-js-cart-count')) {
          countEl.setAttribute('data-js-cart-count', actualCount);
        }
      });

      console.log('[Cart Goals] Updated cart count to:', actualCount, 'in', headerCartCounts.length + 1, 'locations');
    }

    triggerConfetti() {
      const canvas = document.getElementById('cart-goals-confetti');
      if (!canvas) return;

      // Get the container dimensions to confine confetti
      const container = this.container;
      const containerRect = container.getBoundingClientRect();

      const ctx = canvas.getContext('2d');
      canvas.width = containerRect.width;
      canvas.height = containerRect.height;

      const confetti = [];
      const confettiCount = 50; // Reduced from 150
      const gravity = 1.2; // Increased for faster fall
      const terminalVelocity = 8; // Increased for faster movement
      const drag = 0.075;
      const colors = [
        { front: '#4CAF50', back: '#81C784' },
        { front: '#2196F3', back: '#64B5F6' },
        { front: '#FF9800', back: '#FFB74D' },
        { front: '#E91E63', back: '#F48FB1' },
        { front: '#9C27B0', back: '#BA68C8' }
      ];

      const randomRange = (min, max) => Math.random() * (max - min) + min;

      const initConfetti = () => {
        for (let i = 0; i < confettiCount; i++) {
          confetti.push({
            color: colors[Math.floor(randomRange(0, colors.length))],
            dimensions: {
              x: randomRange(8, 15), // Slightly smaller
              y: randomRange(8, 20)
            },
            position: {
              x: randomRange(0, canvas.width),
              y: canvas.height - 1
            },
            rotation: randomRange(0, 2 * Math.PI),
            scale: {
              x: 1,
              y: 1
            },
            velocity: {
              x: randomRange(-15, 15), // Reduced horizontal spread
              y: randomRange(0, -35) // Reduced upward velocity for shorter duration
            }
          });
        }
      };

      const render = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confetti.forEach((confetto, index) => {
          let width = confetto.dimensions.x * confetto.scale.x;
          let height = confetto.dimensions.y * confetto.scale.y;

          ctx.translate(confetto.position.x, confetto.position.y);
          ctx.rotate(confetto.rotation);

          confetto.velocity.x -= confetto.velocity.x * drag;
          confetto.velocity.y = Math.min(confetto.velocity.y + gravity, terminalVelocity);
          confetto.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

          confetto.position.x += confetto.velocity.x;
          confetto.position.y += confetto.velocity.y;

          if (confetto.position.y >= canvas.height) confetti.splice(index, 1);

          if (confetto.position.x > canvas.width) confetto.position.x = 0;
          if (confetto.position.x < 0) confetto.position.x = canvas.width;

          confetto.scale.y = Math.cos(confetto.position.y * 0.1);
          ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;

          ctx.fillRect(-width / 2, -height / 2, width, height);

          ctx.setTransform(1, 0, 0, 1, 0, 0);
        });

        if (confetti.length > 0) {
          window.requestAnimationFrame(render);
        } else {
          canvas.style.display = 'none';
        }
      };

      canvas.style.display = 'block';
      initConfetti();
      render();
    }
  }

  // MutationObserver to watch for element appearing/disappearing
  const observer = new MutationObserver((mutations) => {
    const element = document.querySelector('[data-cart-goals]');
    
    if (element && (!globalInstance || !document.contains(globalInstance.container))) {
      console.log('[Cart Goals] !!!! MutationObserver: Element appeared, creating instance and FETCHING CART');
      globalInstance = new CartGoals(globalCartState);
      
      // ALWAYS fetch latest cart when element appears
      if (globalInstance && globalInstance.container) {
        globalInstance.fetchCartAndUpdate();
      }
    }
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initialize immediately if element exists
  const initialElement = document.querySelector('[data-cart-goals]');
  if (initialElement) {
    console.log('[Cart Goals] Initial element found, creating instance');
    globalInstance = new CartGoals(null);
  }

  // AGGRESSIVE: Listen to ALL cart events and ALWAYS FETCH
  document.addEventListener('cart:updated', (evt) => {
    console.log('[Cart Goals] !!!! CART UPDATED EVENT - FETCHING CART');

    setTimeout(() => {
      if (globalInstance && globalInstance.container && document.contains(globalInstance.container)) {
        // DON'T fetch if we're currently adding free products - let that process complete
        if (!globalInstance.isAddingFreeProducts && !globalInstance.isUpdating) {
          console.log('[Cart Goals] Fetching cart after update...');
          globalInstance.fetchCartAndUpdate();
        } else {
          console.log('[Cart Goals] Skipping fetch - already updating or adding free products');
        }
      } else {
        console.log('[Cart Goals] No valid instance, MutationObserver will handle');
      }
    }, 100);
  });

  document.addEventListener('cart:item-added', () => {
    console.log('[Cart Goals] !!!! ITEM ADDED - FETCHING CART');
    
    setTimeout(() => {
      if (globalInstance && globalInstance.container && document.contains(globalInstance.container)) {
        console.log('[Cart Goals] Fetching cart after item added...');
        globalInstance.fetchCartAndUpdate();
      }
    }, 100);
  });

  document.addEventListener('quick-cart:open', (evt) => {
    console.log('[Cart Goals] !!!! QUICK CART OPENED - FETCHING CART');
    
    setTimeout(() => {
      if (globalInstance && globalInstance.container && document.contains(globalInstance.container)) {
        console.log('[Cart Goals] Fetching cart after drawer opened...');
        globalInstance.fetchCartAndUpdate();
      } else {
        console.log('[Cart Goals] No valid instance yet, will be created by MutationObserver');
      }
    }, 200);
  });

  // Most important - when drawer content refreshes
  document.addEventListener('quick-cart:updated', () => {
    console.log('[Cart Goals] !!!! QUICK CART UPDATED (DRAWER REFRESHED) - FETCHING CART');

    setTimeout(() => {
      const element = document.querySelector('[data-cart-goals]');

      if (element) {
        // Create new instance if needed
        if (!globalInstance || !document.contains(globalInstance.container)) {
          console.log('[Cart Goals] Creating new instance after drawer refresh');
          globalInstance = new CartGoals(null);
        } else if (globalInstance && globalInstance.container) {
          // CRITICAL FIX: Reset ALL locks first, then wait before fetching
          // This allows user interactions to happen immediately after drawer refresh
          console.log('[Cart Goals] Resetting ALL locks after drawer refresh');
          globalInstance.isUpdating = false;
          globalInstance.isAddingFreeProducts = false;
          globalInstance.pendingUpdate = false;

          // Wait longer before fetching to allow user interactions
          setTimeout(() => {
            console.log('[Cart Goals] Fetching cart after drawer refresh (delayed to allow interactions)...');
            globalInstance.fetchCartAndUpdate();
          }, 300);
        }
      }
    }, 150);
  });
})();
